import { api } from './client';
import type { Item, ItemWithImages, CreateItemInput, ItemStatus } from '../types';

export const itemsApi = {
  list: (params?: { search?: string; status?: ItemStatus; category?: string }) => {
    const qs = new URLSearchParams();
    if (params?.search) qs.set('search', params.search);
    if (params?.status) qs.set('status', params.status);
    if (params?.category) qs.set('category', params.category);
    const query = qs.toString();
    return api.get<Item[]>(`/items${query ? `?${query}` : ''}`);
  },

  get: (id: number) => api.get<ItemWithImages>(`/items/${id}`),

  create: (data: CreateItemInput) => api.post<Item & { matches_found: number }>('/items', data),

  update: (id: number, data: Partial<CreateItemInput> & { status?: ItemStatus }) =>
    api.patch<Item>(`/items/${id}`, data),

  delete: (id: number) => api.delete<{ success: boolean }>(`/items/${id}`),

  addImage: (itemId: number, ziplineUrl: string, ziplineId?: string) =>
    api.post<{ id: number; item_id: number; zipline_url: string; created_at: string }>(
      `/items/${itemId}/images`,
      { zipline_url: ziplineUrl, zipline_id: ziplineId }
    ),

  deleteImage: (itemId: number, imageId: number) =>
    api.delete<{ success: boolean }>(`/items/${itemId}/images/${imageId}`),
};
